/** Spellbook hover previews (client-only mini arena demos). */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type SpellPreviewApi = Record<string, any>;

export const SP: SpellPreviewApi = {};
